import { assign } from "xstate";
import { Product, ProductOpaqueValue } from "@b2bportal/purchase-api";

import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import { getDisruptionCartUpdateParams } from "./selectors";
import {
  DisruptionProtectionProduct,
  PartialParentContextWithAirDisruption,
} from "./types";

export const actions = {
  addDisruptionProducts: assign(
    (context: PartialParentContextWithAirDisruption, _event) => {
      const filterOutDisruptionFromProducts = (
        context[ParentState.cartUpdate].addProducts ?? []
      ).filter((p: ProductOpaqueValue) => p.type !== Product.AirDisruption);

      if (context[ParentState.disruption].selectedOffers.length > 0) {
        const disruptionQuoteRequest = getDisruptionCartUpdateParams({
          context,
        });
        const newDisruptionProduct: DisruptionProtectionProduct = {
          type: Product.AirDisruption,
          value: disruptionQuoteRequest,
        };

        context[ParentState.cartUpdate].addProducts = [
          ...filterOutDisruptionFromProducts,
          newDisruptionProduct,
        ];
      }
      return context;
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject({
  ...actions,
});
